module.exports = __webpack_public_path__ + "static/BCards_Pile-31fc91cc547b4ddbacecf775f091b892.webp";